﻿const API_BASE_URL = 'https://api-dev.dev.dev-cglcloud.com/api/cacp-ai/v1';

const knowledge_base_id_map = {
  'faq': 1,
  'doc': 2
};



const processBuffer = (buffer, onMessage) => {
  const lines = buffer.split('\n');
  for (const line of lines) {
    if (/^data:\s*/.test(line)) {
      try {
        // window.console.log(line, '===============line2');
        const data = JSON.parse(line?.slice(5)?.trim());
        onMessage(data);
      } catch (e) {
        console.warn('解析最终缓冲区JSON失败:', e.message);
      }
    }
  }
}

export const sendMessageStream = async (param, onMessage, onError, onComplete) => {
  try {
    const token = localStorage.getItem('accessToken');
    const { userMessage, type } = param;
    const response = await fetch(`${API_BASE_URL}/chat/sendMessage?message=${encodeURIComponent(userMessage)}&type=${type}`, {
      method: 'GET',
      headers: {
        'Accept': 'text/event-stream',
        'authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP错误! 状态码: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        // 处理缓冲区中剩余的数据
        if (buffer.trim() !== '') {
          processBuffer(buffer, onMessage);
        }
        break;
      }
      buffer += decoder.decode(value, { stream: true });

      // / 处理缓冲区中的完整消息
      const lines = buffer.split('\n');
      buffer = lines.pop(); // 最后一行可能不完整，放回缓冲区

      for (const line of lines) {
        // window.console.log(line, '===============line0');
        // window.console.log(/^data:\s*/.test(line), '===============/^datatest(line)');
        if (/^data:\s*/.test(line)) {
          try {
            // window.console.log(line, '===============line1');
            const data = JSON.parse(line?.slice(5)?.trim());
            // window.console.log(data, '===============data');

            onMessage(data);
          } catch (e) {
            console.warn('解析JSON失败，跳过该消息:', e.message, '内容:', line);
            // 可以选择性地调用onError或只是跳过错误数据
          }
        }
      }


      // const chunk = decoder.decode(value);
      // window.console.log(chunk, '===============chunk');

      // if(chunk.includes('data:')) {
      //   const data = JSON.parse(chunk.slice(5));
      //   onMessage(data);
      // }
    }

    onComplete();
  } catch (error) {
    console.error('流处理错误:', error);
    onError(error);
  }
};

export const chatCompletions = async (param, onMessage, onError, onComplete) => {
  try {
    const token = localStorage.getItem('accessToken');
    //const session_id = localStorage.getItem('session_id') || '';
    const { userMessage, type, apiPath = '' } = param;
    const response = await fetch(`${apiPath || API_BASE_URL}/chat/completions`, {
      method: 'POST',
      headers: {
        'Accept': 'text/event-stream',
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        knowledge_base_id: knowledge_base_id_map[type],
        similarity: 0.5,
        temperature: 0.5,
        top_k: 10,
        type: type,
        //session_id,
        message: userMessage,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP错误! 状态码: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        // 处理缓冲区中剩余的数据
        if (buffer.trim() !== '') {
          processBuffer(buffer, onMessage);
        }
        break;
      }
      buffer += decoder.decode(value, { stream: true });

      // / 处理缓冲区中的完整消息
      const lines = buffer.split('\n');
      buffer = lines.pop(); // 最后一行可能不完整，放回缓冲区
      for (const line of lines) {
        if (/^data:\s*/.test(line)) {
          try {
            const data = JSON.parse(line?.slice(5)?.trim());
            onMessage(data);
          } catch (e) {
            console.warn('解析JSON失败，跳过该消息:', e.message, '内容:', line);
          }
        }
      }
    }

    onComplete();
  } catch (error) {
    console.error('流处理错误:', error);
    onError(error);
  }
};

export const getChatbotIndex = async (apiPath = '') => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${apiPath || API_BASE_URL}/v1/chatbot/index`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP错误! 状态码: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('获取chatbot index错误:', error);
    throw error;
  }
};

// 获取历史聊天记录 
export const getChatHistoryListApi = async (apiPath = '') => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${apiPath || API_BASE_URL}/chat/history`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP错误! 状态码: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('获取获取历史聊天记录错误:', error);
    throw error;
  }
};

// curl --location --request POST 'http://localhost:5000/api/cacp-ai/v1/chat/audio/transcribe' \ --header 'Authorization: Bearer xxx' \ --form 'audio_url="https://dashscope.oss-cn-beijing.aliyuncs.com/audios/welcome.mp3"' \ --form 'audio_file=@"C:\\Users\\xunyang\\PycharmProjects\\cacp-ai-assistant\\logs\\welcome.mp3"' \ --form 'audio_mime_type="audio/mpeg"'
export const audioTranscribeApi = async (param, onMessage, onError) => {
  try {
    const token = localStorage.getItem('accessToken');
    const { audio_file, audio_url, audio_mime_type } = param;
    // 通过formdata形式传参
    const formData = new FormData();
    if (audio_file) {
      formData.append('audio_file', audio_file);
    }
    if (audio_url) {
      formData.append('audio_url', audio_url);
    }
    if (audio_mime_type) {
      formData.append('audio_mime_type', audio_mime_type);
    }

    const response = await fetch(`${API_BASE_URL}/chat/audio/transcribe`, {
      method: 'POST',
      headers: {
        'authorization': `Bearer ${token}`,
      },

      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP错误! 状态码: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('音频转录错误:', error);
    throw error;
  }
};


export const downloadFile = async (apiPath = '', param) => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${apiPath || API_BASE_URL}/sql/export?uuid=${param?.uuid}`, {
      method: 'GET',
      headers: {
        'authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP错误! 状态码: ${response.status}`);
    }

    // 获取二进制流数据
    const blob = await response.blob();
    
    // 尝试多种方式获取 Content-Disposition
    let contentDisposition = response.headers.get('Content-Disposition') || 
                            response.headers.get('content-disposition');
    
    let filename = 'export.xlsx'; // 默认文件名
    
    if (contentDisposition) {
      // 方式1: 标准格式 filename="xxx.xlsx"
      let filenameMatch = contentDisposition.match(/filename="([^"]+)"/i);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      } else {
        // 方式2: 无引号格式 filename=xxx.xlsx
        filenameMatch = contentDisposition.match(/filename=([^;,\s]+)/i);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }
      
      // 方式3: UTF-8 编码格式 filename*=UTF-8''xxx.xlsx（优先级最高）
      const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
      if (utf8Match && utf8Match[1]) {
        try {
          filename = decodeURIComponent(utf8Match[1]);
        } catch (e) {
          console.error('UTF-8 解码失败:', e);
        }
      }
    }
    
    // 创建下载链接并触发下载
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    
    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
    
    return { success: true, filename };
  } catch (error) {
    console.error('下载文件错误:', error);
    throw error;
  }
};